module.exports = __webpack_public_path__ + "img/ltkseasonal-2x.70e3cc8.jpg";